var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-sm-10"},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.site_key},on:{"verify":_vm.onVerify}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }